import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import API from '../../../src/config/axios.config';
import { API_ENDPOINTS } from '../../../src/shared/api-endpoints';

interface GetTokenSpeechState {
	tokenResponse: any;
	status: boolean;
	error: string | null;
}

const initialState: GetTokenSpeechState = {
	tokenResponse: {},
	status: false,
	error: null
};

const getTokenSpeechApi = createAsyncThunk<any, void>('getTokenSpeechApi/getTokenSpeechApi', async (_, thunkAPI) => {
	try {
		const response = await API.get(API_ENDPOINTS.GET_TOKEN_SPEECH);
		return response;
	} catch (error: any) {
		return thunkAPI.rejectWithValue(error.response.data);
	}
});

const getTokenSpeechApiSlice = createSlice({
	name: 'getTokenSpeechApi',
	initialState,
	reducers: {
		reset: () => initialState
	},
	extraReducers: (builder) => {
		builder
			.addCase(getTokenSpeechApi.pending, (state) => {
				state.status = true;
				state.error = null;
			})
			.addCase(getTokenSpeechApi.fulfilled, (state, action: PayloadAction<any>) => {
				state.status = false;
				state.tokenResponse = action.payload;
			})
			.addCase(getTokenSpeechApi.rejected, (state, action) => {
				state.status = false;
				state.error = action.error.message || 'Failed to fetch token for speech';
			});
	}
});

export { getTokenSpeechApi };
export const { reset: resetGetTokenSpeechApi } = getTokenSpeechApiSlice.actions;
export const getTokenSpeechApiReducer = getTokenSpeechApiSlice.reducer;
